import { getType } from 'typesafe-actions';
import { globalActions, GlobalActions } from './actions';

export interface commonGlobalState {
  export_datas: any;
}

export const initialState: commonGlobalState = {
  export_datas: {},
};

export const reducer = (
  state: commonGlobalState = initialState,
  action: GlobalActions,
): commonGlobalState => {
  switch (action.type) {
    case getType(globalActions.setExport):
      return {
        ...state,
        export_datas: action.payload,
      };

    default:
      return state;
  }
};
